<div class="stepper-actions">
    <nb-actions size="small">
        <nb-action>Load Background Image</nb-action>
        <nb-action title="Background Image"
            class="popover-icon"
            (click)="imageDialog()">
            <nb-icon icon="image-outline" pack="eva" title="Edit Image"></nb-icon>
        </nb-action>
    </nb-actions>
</div>
<div class="preview-content" [attr.id]="cell.cellId">
    <div class="image-container">
        <img 
          [src]="imgSrc"
          (error)="onImageError()"
          alt="Image placeholder"
          *ngIf="!showPlaceholder"
        />
        <ng-container *ngIf="showPlaceholder">
            <svg 
                width="100%" 
                height="100%" 
                xmlns="http://www.w3.org/2000/svg" 
                class="placeholder">
                <rect width="100%" height="100%" fill="#e0e0e0" />
                <text x="50%" y="50%" font-size="16" fill="#333" text-anchor="middle" dy=".3em">Image goes here</text>
              </svg>
        </ng-container>
      </div>
</div>
